var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_2259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6407 1.71094H1.35889V32.6582H42.6407V1.71094Z",
    fill: "white",
    stroke: "#3C8EB0",
    strokeWidth: 2.70419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6407 1.71094L21.9998 22.9181L1.35889 1.71094",
    stroke: "#3C8EB0",
    strokeWidth: 2.70419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35889 32.6294L16.6201 17.3965",
    stroke: "#3C8EB0",
    strokeWidth: 2.70419,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6407 32.6294L27.3794 17.3965",
    stroke: "#3C8EB0",
    strokeWidth: 2.70419,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 33.6371,
    fill: "white",
    transform: "translate(0 0.351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.978ca054a2afb7dbc563e15072aaf295.svg";
export { ForwardRef as ReactComponent };